module.exports = __webpack_public_path__ + "static/media/icon-pause.35cc3e5f.svg";